import React from 'react';
import { Chip, Divider, Grid, TextField, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { styles } from './styles';

const CompanyData = ({ company }) => {
    const details = [
        {
            Section: 'Basic details',
            'Company name': company?.company?.customer?.customerName,
            Status: (
                <Chip
                    label={company?.company?.customer?.customerStatus}
                    size="small"
                    sx={{
                        mt: 2,
                        backgroundColor:
                            company?.company?.customer?.customerStatus?.toLowerCase() === 'active'
                                ? '#BCE2E2'
                                : '#FFE1D3',
                    }}
                />
            ),
            'No. of employees': company?.company?.customer?.numberOfEmployees,
            Description: (
                <TextField
                    fullWidth
                    size="small"
                    variant="outlined"
                    disabled
                    multiline
                    name="description"
                    rows={4}
                    value={company?.company?.customer?.description}
                />
            ),
            'Company Slug': company?.company?.companySlug,
            'Created Date': company?.company?.createdOn,
        },
        {
            Section: 'Client Setup Details',
            'ANSR HQ': (
                <Chip
                    label={company?.company?.isAnsrHqEnabled ? 'Active' : 'Inactive'}
                    size="small"
                    sx={{
                        mt: 2,
                        backgroundColor: company?.company?.isAnsrHqEnabled ? '#BCE2E2' : '#FFE1D3',
                    }}
                />
            ),
            'Client HQ': (
                <Chip
                    label={company?.company?.isClientHqEnabled ? 'Active' : 'Inactive'}
                    size="small"
                    sx={{
                        mt: 2,
                        backgroundColor: company?.company?.isClientHqEnabled ? '#BCE2E2' : '#FFE1D3',
                    }}
                />
            ),
        },
        {
            Section: 'Company configuration',
            'Client Disengagement': (
                <Chip
                    label={company?.company?.isClientDisengaged ? 'Active' : 'Inactive'}
                    size="small"
                    sx={{
                        mt: 2,
                        backgroundColor: company?.company?.isClientDisengaged ? '#BCE2E2' : '#FFE1D3',
                    }}
                />
            ),
            'ESB Enabled': (
                <Chip
                    label={company?.company?.config?.isEsbEnabled ? 'Active' : 'Inactive'}
                    size="small"
                    sx={{
                        mt: 2,
                        backgroundColor: company?.company?.config?.isEsbEnabled ? '#BCE2E2' : '#FFE1D3',
                    }}
                />
            ),
            'Integrated with Canvas': (
                <Chip
                    label={company?.company?.config?.isIntegratedWithCanvas ? 'Active' : 'Inactive'}
                    size="small"
                    sx={{
                        mt: 2,
                        backgroundColor: company?.company?.config?.isIntegratedWithCanvas ? '#BCE2E2' : '#FFE1D3',
                    }}
                />
            ),
        },
        {
            Section: 'Address',
            'Location name': company?.address?.locationName,
            'Address Line 1': company?.address?.addressLine1,
            'Address Line 2': company?.address?.addressLine2,
            'Address Line 3': company?.address?.addressLine3,
            City: company?.address?.city,
            State: company?.address?.state,
            Country: company?.address?.country,
            'Postal/Zip code': company?.address?.pinOrZip,
        },
    ];

    return (
        <Grid container spacing={4}>
            <Grid item md={12} xs={12}>
                {details.map((detail, index) => (
                    <>
                        <Grid
                            container
                            spacing={3}
                            sx={{
                                mb: 5,
                            }}
                        >
                            <Grid item xs={12}>
                                <Box sx={styles.titleWrapper}>
                                    <Typography color="neutral.600" variant="subtitle2">
                                        {detail.Section}
                                    </Typography>
                                </Box>
                            </Grid>
                            {Object.keys(detail)
                                .filter((_, key) => key)
                                .map((key) => (
                                    <Grid
                                        item
                                        xs={key === 'Description' ? 12 : 4}
                                        sx={{
                                            pt: '32px !important',
                                        }}
                                    >
                                        <Typography color="neutral.600" variant="body2">
                                            {key}
                                        </Typography>
                                        {typeof detail[key] === 'string' || !detail[key] ? (
                                            <Typography
                                                color="neutral.700"
                                                variant="h6"
                                                sx={{
                                                    pt: 2,
                                                }}
                                            >
                                                {detail[key] || '-'}
                                            </Typography>
                                        ) : (
                                            detail[key]
                                        )}
                                    </Grid>
                                ))}
                        </Grid>
                        {index !== details.length - 1 && <Divider />}
                    </>
                ))}
            </Grid>
        </Grid>
    );
};

export default CompanyData;
